export default __webpack_public_path__ + "static/media/dirtwall.265c358f.png";